<template lang="pug">
  .display-none
    app-dialog(v-model="dialog.main" header="Выбранный файл" :items="fileItems")
    app-dialog-confirm(v-model="dialog.delete" ref="dialogDelete" confirm-button="Удалить" @confirm="deleteFile(file)") Удалить файл <b>"{{ file.name }}"</b>?
  
    app-dialog(v-model="dialog.rename" ref="dialogRename" header="Переименование / изменение тегов" confirm-text="Сохранить" :confirm-disabled="!renameReady" @confirm="renameFile(renameFileObj)")
      app-card-headline {{ file.name }}
      app-text-field(v-model="editableFile.name" label="Новое имя файла" counter="90")
      app-tags-combobox(v-model="editableFile.tags" :items="sortedTags")

    app-dialog(v-model="dialog.copy" ref="dialogCopy" header="Сохранение копии" confirm-text="Сохранить" :confirm-disabled="!copyReady" @confirm="copyFile(copyFileObj)")
      app-card-headline {{ file.name }}
      app-text-field(v-model="editableFile.copy" label="Новое имя файла" counter="90")
      app-select(v-if="file.isDoc" v-model="editableFile.folder" :items="sortedFolders" item-text="name" label="В какую папку")
      app-tags-combobox(v-model="editableFile.tags" :items="sortedTags")
      
    app-dialog(v-model="dialog.move" ref="dialogMove" header="Перемещение файла" confirm-text="Сохранить" :confirm-disabled="!moveReady" @confirm="moveFile(moveFileObj)")
      app-card-headline {{ file.name }}
      app-text-field(v-model="file.folder.name" label="Из папки" disabled)
      app-select(v-model="editableFile.folder" :items="sortedFolders" item-text="name" label="В какую папку")

    app-dialog(v-model="dialog.transform" ref="dialogTransform" header="Преобразовать в шаблон" confirm-text="Сохранить" :confirm-disabled="!transformReady" @confirm="transformDocToTemplate(transformFileObj)")
      app-card-headline {{ file.name }}
      app-text-field(v-model="editableFile.name" label="Новое имя файла" counter="90")
      app-tags-combobox(v-model="editableFile.tags" :items="sortedTags")
</template>

<script>
import { fileService } from '@/_services'
import { mapGetters, mapActions } from 'vuex'
import { AppDialogToggable } from "@/components"

let baseFile = { folder: { name: null }, name: null, tags: [] }

export default {
  mixins: [AppDialogToggable],
  computed: {
    ...mapGetters('fileStore', ['sortedTags', 'sortedFolders']),

    fileItems () {
      let common = [
        { icon: 'edit', title: 'Редактировать', action: () => this.openDoc() },
        { icon: 'title', title: 'Переименовать / изменить тег', action: () => this.$refs.dialogRename.show() },
        { icon: 'file_copy', title: 'Сохранить копию', action: () => this.$refs.dialogCopy.show() }
      ]
      let move = { icon: 'how_to_vote', title: 'Переместить', action: () => this.$refs.dialogMove.show() }
      let transform = { icon: 'transform', title: 'Преобразовать в шаблон', action: () => this.$refs.dialogTransform.show() }
      let remove = { icon: 'delete', title: 'Удалить', action: () => this.$refs.dialogDelete.show() }
      
      return this.file.isDoc ? [ ...common, move, transform, remove ] : [ ...common, remove]
    },

    renameReady () {
      let nameIsOk = !!this.editableFile.name && this.editableFile.name.length <= 90
      return this.file.isDoc ? nameIsOk : nameIsOk && this.editableFile.tags && this.editableFile.tags.length
    },

    renameFileObj () {
      let baseObj = { id: this.file.id, name: this.editableFile.name, isTemplate: this.file.isTemplate }
      if (this.file.isDoc) {
        baseObj.myTags = this.editableFile.tags.map(item => this.makeTagObject(item)),
        baseObj.myFolder = this.file.folder
      }
      else {
        baseObj.tagged = this.editableFile.tags.map(item => ({ myTag: this.makeTagObject(item) }))
      }
      return baseObj
    },

    copyReady () {
      let nameIsOk = this.editableFile.copy && this.editableFile.copy.length <= 90
      return this.file.isTemplate ? nameIsOk && this.editableFile.tags && this.editableFile.tags.length : nameIsOk && !!this.editableFile.folder
    },

    copyFileObj () {
      let baseObj = { id: this.file.id, name: this.editableFile.copy, isTemplate: this.file.isTemplate }
      if (this.file.isDoc) {
        baseObj.myTags = this.editableFile.tags.map(item => this.makeTagObject(item)),
        baseObj.myFolder = this.editableFile.folder
      }
      else {
        baseObj.tagged = this.editableFile.tags.map(item => ({ myTag: this.makeTagObject(item) }))
      }
      return baseObj
    },

    moveReady () {
      return this.editableFile.folder
    },

    moveFileObj () {
      return {
        id: this.file.id,
        name: this.file.name,
        myTags: this.file.tags,
        myFolder: this.editableFile.folder,
      }
    },

    transformReady () {
      return this.editableFile.tags && this.editableFile.tags.length && this.editableFile.name && this.editableFile.name.length <= 90
    },

    transformFileObj () {
      return {
        id: this.file.id,
        name: this.editableFile.name,
        tagged: this.editableFile.tags.map(item => ({ myTag: this.makeTagObject(item) })),
        isTemplate: this.file.isTemplate
      }
    }
  },

  methods: {
    ...mapActions('fileStore', ['deleteFile', 'renameFile', 'copyFile', 'moveFile', 'transformDocToTemplate']),

    $_beforeShow (file) {
      this.file = file
      this.editableFile = { ...file, copy: `${file.name} (Копия)` }
      this.dialog.main = true
    },

    openDoc () {
      let { id, isTemplate } = this.file
      fileService.getFileURL(id, isTemplate).then(data => { 
        let link="ms-word:ofe|u|"+document.location.origin+data
        window.open(link, '_blank') 
      })
    },

    makeTagObject (tag) {
      return tag instanceof Object ? tag : this.sortedTags.find(x => x.name === tag) || { name: tag }
    }
  },

  data () {
    return {
      file: { ...baseFile },
      editableFile: { ...baseFile, copy: null },

      dialog: {
        main: false,
        rename: false,
        copy: false,
        move: false,
        transform: false,
        delete: false
      },
    }
  }
}
</script>